<style lang="scss" scoped>
.slide-5 {
  background-image: url(../../../assets/module5/slide5/bg-06.jpg);
  background-size: cover;
  background-position: center;
  padding-top: 40px;
  padding-left: 75px;
  padding-right: 75px;
  height: calc(100% - 40px);
  display: flex;
  justify-content: flex-end;
}
h1 {
  font-size: 98px;
  color: #c5d43b;
  transform: rotate(-5deg);
  position: absolute;
  left: 75px;
  top: 75px;
}
p {
  color: white;
}
.content {
  width: 760px;
  //   margin-top: 60px;
  span {
    color: white;
    font-size: 117px;
    font-family: "Kookycat-FASTcaps";
  }
}
h2 {
  color: #39622a;
  font-size: 70px;
  line-height: 84px;
  margin-top: 10px;
}
.top {
  display: flex;
  align-items: center;
  p {
    margin-right: 30px;
  }
}
.cut {
  shape-outside: polygon(0 0, 0 200px, 200px 300px);
  width: 300px;
  height: 200px;
  float: left;
  opacity: 0.2;
  display: block;
}
.frank {
  z-index: 9;
}
</style>

<template>
  <div class="slide-5">
    <transition name="fadeUp" appear>
      <img
        v-show="slideIndex == 4"
        src="@/assets/module5/slide5/frank-06.png"
        class="chars frank delay-2"
      />
    </transition>

    <transition name="fadeUp" appear>
      <img
        v-show="slideIndex == 4"
        src="@/assets/module5/slide5/photo-06.png"
        class="chars delay-3"
      />
    </transition>

    <transition name="fadeUp" appear>
      <img
        v-show="slideIndex == 4"
        src="@/assets/module5/slide5/number-06.png"
        class="chars delay-1"
      />
    </transition>

    <h1>
      <transition name="fadeUp" appear>
        <div v-show="slideIndex == 4">
          Do you remember<br />our superheroes?
        </div>
      </transition>
    </h1>

    <transition name="scale" appear>
      <div class="content delay-4" v-show="slideIndex == 4">
        <div class="top">
          <p>First we met</p>
          <span>FRANC</span>
        </div>
        <p>His superpower is</p>
        <h2>funny face pulling.</h2>
        <div>
          <!-- <div class="cut"></div> -->
          <p>
            But if the Evil Clot attacks Franc he will have a stroke and he will
            lose his superpower. He might lose control over 1 side of his face
            which will suddenly start drooping downwards.
          </p>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: ["slideIndex"]
};
</script>
